import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { ILocationTag } from 'src/interfaces';
import { lang, queryKeys, requestCCApi } from 'src/utils';
import { improvedFailedToError } from 'src/utils/improvedFailedToError';

export const useCreateLocationTag = () => {
  return useMutation({
    mutationFn: createLocationTag,
    onSuccess() {
      queryClient.invalidateQueries(queryKeys.viewLocations.invalidateAll());
      queryClient.invalidateQueries(queryKeys.locationTags.invalidateAll());
      queryClient.invalidateQueries(queryKeys.locations.invalidateAll());
    },
  });
};

const createLocationTag = async (payload: Partial<ILocationTag>) => {
  const request = {
    name: payload.name,
  };

  const response = await requestCCApi(
    {
      url: `/locationTags`,
      method: 'POST',
      data: { data: request },
    },
    true,
    improvedFailedToError(lang.create, lang.locationTag),
  );

  return response;
};
